<template>
    <div id="page" class="container-fluid">
        <div class="row header mx-4 mt-3">
            <div class="col header-row">
                <h1>Estimates <b-button title="Add New Patient" class="ml-3" variant="outline-orange" @click.prevent="addPatient()">
                  <font-awesome-icon class="orange" icon="plus"/>
                  Add New Patient
                </b-button></h1>
            </div>
            <div class="row filter-row mb-1">
                  <div class="patient-search-section mr-2">
                    <b-input-group class="patient-search-border text-right">
                        <b-form-input ref="searchInput"
                                      placeholder="Filter (Patient Name or ID)"
                                      class="patient-search"
                                      v-model="searchTerm"></b-form-input>
                        <b-input-group-append>
                            <button class="btn btn-default patient-search-submit" type="button">
                                <font-awesome-icon icon="search"/>
                            </button>
                        </b-input-group-append>
                    </b-input-group>
                  </div>
                  <b-form-group class="mr-2" label-class="ml-2" label="Start Date">
                    <b-form-datepicker :date-format-options="{month: 'short', day: 'numeric', year: 'numeric'}"
                                       :hide-header="true"
                                       :value-as-date="true"
                                       class="date-search orange-border form-control datepicker"
                                       v-model="fromDate">
                    </b-form-datepicker>
                  </b-form-group>
                  <b-form-group label-class="ml-2" label="End Date">
                    <b-form-datepicker :date-format-options="{month: 'short', day: 'numeric', year: 'numeric'}"
                                       v-model="toDate"
                                       offset="-100"
                                       text="Offset Dropdown"
                                       :hide-header="true"
                                       :value-as-date="true"
                                       class="date-search orange-border form-control">
                    </b-form-datepicker>
                  </b-form-group>
              </div>
        </div>
          <div class="row header">
            <div class="col ml-4">
            </div>
            <div class="row text-right mx-4 pb-4">
              <b-form-checkbox class="mr-2 mt-2" v-model="includeArchived">
                <span style="vertical-align:middle"> Show Archived Estimates</span>
              </b-form-checkbox>
              <b-dropdown variant="outline-orange" class="dropdown-button mr-2" menu-class="dropdown-container" :text="dateFieldName">
                <b-dropdown-item @click.prevent="selectDateField('createdAt')">Created</b-dropdown-item>
                <b-dropdown-item @click.prevent="selectDateField('procedureDate')">Service</b-dropdown-item>
              </b-dropdown>
                  <button name="providers" class="btn btn-outline-orange providers-filter mr-2"
                          @click.prevent="showingLocationList = !showingLocationList">
                    <font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'location-dot' ]"/>Locations <b-badge v-show="selectedLocationIds.length > 0" variant="orange">{{ selectedLocationIds.length }}</b-badge>
                  </button>
                  <button name="providers" class="btn btn-outline-orange providers-filter"
                          @click.prevent="showingProviderList = !showingProviderList">
                    <font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'user-doctor' ]"/>Providers <b-badge v-show="selectedProviderIds.length > 0" variant="orange">{{ selectedProviderIds.length }}</b-badge>
                  </button>
            </div>
          </div>

        <div class="container-fluid">
            <div class="row visits-header">
                <div class="col-1"><a href="#" @click.prevent="sort('CreatedAt')">Created {{ sortIndicator ('CreatedAt') }}</a></div>
                <div class="col-1"><a href="#" @click.prevent="sort('Patient')">Patient {{ sortIndicator ('Patient') }}</a></div>
                <div class="col-1"><a href="#" @click.prevent="sort('Provider')">Provider {{ sortIndicator ('Provider') }}</a></div>
                <div class="col-1"><a href="#" @click.prevent="sort('Location')">Location {{ sortIndicator ('Location') }}</a></div>
                <div class="col-1"><a href="#" @click.prevent="sort('ProcedureDate')">Date of Service {{ sortIndicator ('ProcedureDate') }}</a></div>
                <div class="col-1"><a href="#" @click.prevent="sort('Notified')">Notification Sent {{ sortIndicator ('Notified') }}</a></div>
                <div class="col-1"><a href="#" @click.prevent="sort('Total')">Total {{ sortIndicator ('Total') }}</a></div>
                <div class="col-1"><a href="#" @click.prevent="sort('PatientTotal')">Patient Total {{ sortIndicator ('PatientTotal') }}</a></div>
                <div class="col-1"><a href="#" @click.prevent="sort('AmountPaid')">Amount Paid {{ sortIndicator ('AmountPaid') }}</a></div>
                <div class="col-3"></div>
            </div>
            <div v-for="estimate in estimates" class="row visit-row" :key="estimate.organizationPatientEstimateId">
                <div class="column col-1">{{ formatDate(estimate.createdAt) }}</div>
                <div class="column col-1">{{ estimate.patient.firstName + ' ' + estimate.patient.lastName }}</div>
                <div class="column col-1">{{ estimate.providerName }}</div>
                <div class="column col-1">{{ estimate.location.name }}</div>
                <div class="column col-1">{{ formatDate(estimate.procedureDate) }}</div>
                <div class="column col-1">{{ formatLastSent(estimate.emailLastSentAt) }}</div>
                <div v-if="!estimate.bundle" class="column col-1">${{ formatNumber(estimate.estimateTotal) }}</div>
              <div v-if="estimate.bundle" class="column col-1">${{ bundleAmountTotal(estimate) }}</div>
                <div class="column col-1">${{ formatNumber(estimate.patientTotal) }}</div>
                <div class="column col-1">${{ formatNumber(estimate.amountPaid) }}</div>
                <div class="column col-3 text-right">
                    <button title="Edit" @click.prevent="editEstimate(estimate)" type="button" class="btn btn-outline-orange m-1 wide-button">
                        <font-awesome-icon class="orange mr-2" :icon="['far', 'edit']"/>Edit
                    </button>
                  <button v-if="isAdmin" :disabled="estimate.payments.length > 0" title="Delete" @click.prevent="deleteEstimateConfirmation(estimate)" type="button" class="btn btn-outline-orange m-1 wide-button">
                    <font-awesome-icon class="orange mr-2" :icon="['far', 'trash-alt']"/>Delete
                  </button>
                  <button v-if="estimate.isArchived === false" title="Archive" @click.prevent="confirmEstimateArchive(estimate)" type="button" class="btn btn-outline-orange m-1 wide-button">
                    <font-awesome-icon class="orange mr-2" :icon="['far', 'box-archive']"/>Archive
                  </button>
                </div>
            </div>
        </div>

        <div class="alert alert-secondary" role="alert" v-show="!estimates.length && !errors.length">
            &nbsp;&nbsp;No estimates were found for the specified locations, providers and date range
        </div>

        <div class="row justify-content-center m-2">
            <div class="alert alert-danger col-6" role="alert" v-show="errors.length > 0">
                <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
            </div>
        </div>
      <confirm-modal @confirmed="archiveConfirmed" class="align-middle"
                     confirmButton="Archive"
                     title="Archive Estimate"
                     :visible="showingConfirmModal"
                     @update:visible="visible => showingConfirmModal = visible">
        <div class="row mb-3">
          <div class="col-2"></div>
          <div class="col-8 mt-2 text-center">
            <div class="text-center">
              <font-awesome-icon size="sm" class="text-warning mr-2 align-baseline" icon="exclamation-triangle"/>
              Are you sure you want to archive this estimate?
            </div>
          </div>
          <div class="col-2"></div>
        </div>
      </confirm-modal>
        <location-select @saveLocationIds="locationSelectionChanged"
                         :selected-location-ids="selectedLocationIds" :visible="showingLocationList"
                         @update:visible="visible => showingLocationList = visible"></location-select>
        <provider-select @saveProviderIds="providerSelectionChanged"
                         :selected-provider-ids="selectedProviderIds" :visible="showingProviderList"
                         @update:visible="visible => showingProviderList = visible"></provider-select>
        <loading-modal :visible="showingLoadingModal" :return-focus="$refs.searchInput"
                       @update:visible="visible => showingLoadingModal = visible"></loading-modal>
        <delete-estimate-modal @estimateDeleted="estimateDeleted"
            :estimate="estimate" :visible="showingDeleteEstimateModal" @update:visible="visible => showingDeleteEstimateModal = visible"></delete-estimate-modal>
        <new-patient-modal @newPatientAdded="patientAdded" :visible="showingAddPatientModal"
                           @update:visible="visible => showingAddPatientModal = visible"></new-patient-modal>
        <paginator :totalPages="totalPages" :currentPage="currentPage" @update:currentPage="newPage => currentPage = newPage"></paginator>
    </div>
</template>

<script>
  import LoadingModal from '../components/LoadingModal'
  import Paginator from '../components/Paginator'
  import ProviderSelect from '../components/ProviderSelect'
  import LocationSelect from '../components/LocationSelect'
  import moment from 'moment-timezone'
  import api from '../services/api'
  import _ from 'lodash'
  import DeleteEstimateModal from '../components/DeleteEstimateModal'
  import NewPatientModal from '../components/NewPatientModal'
  import ConfirmModal from '../components/ConfirmModal.vue'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'Estimates',

    components: { ConfirmModal, NewPatientModal, LoadingModal, Paginator, ProviderSelect, LocationSelect, DeleteEstimateModal },

    mixins: [AnalyticsMixin],

    data () {
      return {
        restoringSettings: false,
        showingProviderList: false,
        showingLocationList: false,
        estimates: [],
        estimate: {},
        errors: [],
        searchTerm: '',
        selectedProviderIds: [],
        selectedLocationIds: [],
        fromDate: moment().startOf('day').subtract(30, 'day').utc().toJSON(),
        toDate: moment().endOf('day').utc().toJSON(),
        day: moment().startOf('day').utc().toJSON(),
        toTime: '23:59',
        showingLoadingModal: false,
        showingDeleteEstimateModal: false,
        showingAddPatientModal: false,
        totalPages: 0,
        currentPage: 1,
        pageSize: 20,
        isLoading: false,
        dateField: 'createdAt',
        searchDebounceFn: null,
        sortBy: null,
        sortOrder: null,
        patient: {},
        showingConfirmModal: false,
        isArchived: false,
        includeArchived: false
      }
    },

    watch: {
      fromDate (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },

      toDate (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      searchTerm (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      includeArchived (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      currentPage (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.load()
        }
      }
    },

    computed: {
      dateFieldName () {
        if (this.dateField === 'createdAt') {
          return 'Created'
        }
        return 'Service'
      },

      isAdmin () {
        return this.$store.isAdmin
      },
      toDateTime () {
        if (this.toTime) {
          return moment(moment(this.toDate).format('YYYY/MM/DD') + ' ' + this.toTime, 'YYYY/MM/DD HH:mm').toDate()
        } else {
          return moment(this.toDate).toDate()
        }
      }
    },

    methods: {
      locationSelectionChanged (selectedIds) {
        this.selectedLocationIds = selectedIds
        this.showingLocationList = false
        this.load()
      },

      providerSelectionChanged (selectedIds) {
        this.selectedProviderIds = selectedIds
        this.showingProviderList = false
        this.load()
      },

      editEstimate (estimate) {
        this.$router.push({ name: 'patient-estimate', params: { id: estimate.organizationPatientEstimateId } })
      },

      deleteEstimateConfirmation (estimate) {
        this.showingDeleteEstimateModal = true
        this.estimate = estimate
      },

      estimateDeleted () {
        this.estimate = null
        this.showingDeleteEstimateModal = false
        this.load()
      },

      addPatient () {
        this.showingAddPatientModal = true
      },

      patientAdded (patient) {
        this.showingAddPatientModal = false
        this.$router.push({ name: 'patient-detail', params: { id: patient.organizationPatientId } })
      },
      confirmEstimateArchive (estimate) {
        this.archivableEstimate = estimate
        this.showingConfirmModal = true
      },
      archiveConfirmed (confirmation) {
        this.showingConfirmModal = false
        if (confirmation === true && this.archivableEstimate.organizationPatientEstimateId > 0) {
          this.archiveEstimate(this.archivableEstimate.organizationPatientEstimateId)
        }
        this.archivableEstimate = {
          organizationPatientEstimateId: 0
        }
      },
      archiveEstimate (organizationPatientEstimateId) {
        api.post('/Dashboard/Estimate/Archive/' + organizationPatientEstimateId + '/True').then(response => {
          this.trackEvent('Estimate', 'Archive', response.config.requestDuration)
          this.load()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Estimate', 'EstimateError', error.message)
            this.$log.error('Error setting estimate status: ' + error.message, error)
            this.errors = ['Error updating estimate status: ' + error.message]
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },
      selectDateField (fieldName) {
        this.dateField = fieldName
        this.load()
      },

      load (silent = false) {
        this.$log.info('Loading estimates')

        if (!silent) {
          this.showingLoadingModal = true
        }

        if (this.isLoading) {
          return
        }
        const parameters = {
          searchTerm: this.searchTerm,
          fromDate: this.fromDate,
          toDate: this.toDateTime,
          dateField: this.dateField,
          providerIds: this.selectedProviderIds,
          locationIds: this.selectedLocationIds,
          pageSize: this.pageSize,
          page: this.currentPage,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          includeArchived: false
        }

        if (this.includeArchived) {
          parameters.includeArchived = true
        }

        this.errors = []
        this.isLoading = true
        api.post('/Dashboard/Estimates', parameters).then(response => {
          this.isLoading = false
          this.persistSettings()

          this.estimates = response.data.estimates
          this.currentPage = response.data.page
          this.totalPages = Math.ceil(response.data.totalVisits / this.pageSize)
          this.sortBy = response.data.sortBy
          this.sortOrder = response.data.sortOrder
        }).catch(error => {
          this.isLoading = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load estimates: ' + error.message, error)
            this.errors = ['Error loading estimates: ' + error.message]
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      formatBirthDate (dob) {
        return moment(dob).utc().format('MM/DD/YYYY')
      },

      formatLastSent (lastSentAt) {
        if (lastSentAt) {
          return moment(lastSentAt).format('MM/DD h:mm a')
        } else {
          return ''
        }
      },

      formatDate (date) {
        if (date) {
          return moment(date).utc().format('MM/DD/YYYY')
        } else {
          return ''
        }
      },

      formatNumber (number) {
        if (number) {
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }
        return '0.00'
      },

      bundleAmountTotal (estimate) {
        if (estimate.implantCost && estimate.bundle) {
          const number = estimate.implantCost + estimate.bundle.amount
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }
        if (!estimate.implantCost && estimate.bundle) {
          const number = estimate.bundle.amount
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }
      },
      persistSettings () {
        const estimateFilters = {
          fromDate: moment(this.fromDate).toISOString(),
          toDate: moment(this.toDate).toISOString(),
          providerIds: this.selectedProviderIds,
          locationIds: this.selectedLocationIds,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          searchTerm: this.searchTerm,
          dateField: this.dateField,
          includeArchived: this.includeArchived
        }
        localStorage.setItem('selectedEstimateFilters', JSON.stringify(estimateFilters))
      },

      restoreSettings () {
        this.restoringSettings = true
        const settingEstimateFilters = localStorage.getItem('selectedEstimateFilters')
        if (settingEstimateFilters) {
          const estimateFilters = JSON.parse(settingEstimateFilters)
          if (estimateFilters.fromDate && estimateFilters.fromDate !== 'null') {
            this.fromDate = estimateFilters.fromDate
          }
          if (estimateFilters.toDate && estimateFilters.toDate !== 'null') {
            this.toDate = estimateFilters.toDate
          }
          if (estimateFilters.providerIds) {
            this.selectedProviderIds = estimateFilters.providerIds
          }
          if (estimateFilters.locationIds) {
            this.selectedLocationIds = estimateFilters.locationIds
          }
          if (estimateFilters.sortBy && estimateFilters.sortBy !== 'null') {
            this.sortBy = estimateFilters.sortBy
          }
          if (estimateFilters.sortOrder && estimateFilters.sortOrder !== 'null') {
            this.sortOrder = estimateFilters.sortOrder
          }
          if (estimateFilters.searchTerm) {
            this.searchTerm = estimateFilters.searchTerm
          }
          if (estimateFilters.dateField) {
            this.dateField = estimateFilters.dateField
          }
          if (estimateFilters.includeArchived) {
            this.includeArchived = estimateFilters.includeArchived
          }
        }
        this.$nextTick(() => {
          this.restoringSettings = false
        })
      },

      handleOrgChange (newOrg, event) {
        this.restoreSettings()
        this.load()
      },

      sort (newOrder) {
        if (newOrder === this.sortBy) {
          if (this.sortOrder === 'Descending') {
            this.sortBy = null
            this.sortOrder = null
            this.load()

            return
          } else {
            this.sortOrder = 'Descending'
          }
        } else {
          this.sortOrder = 'Ascending'
        }

        this.sortBy = newOrder
        this.load()
      },

      sortIndicator (sortType) {
        if (sortType === this.sortBy) {
          if (this.sortOrder === 'Descending') {
            return '▼'
          } else {
            return '▲'
          }
        }

        return ''
      }
    },

    created () {
      this.$store.$on('organization:changed', this.handleOrgChange)
      this.searchDebounceFn = _.debounce(() => {
        if (this.searchTerm === '') {
          this.totalPages = Math.ceil(this.estimates.totalEstimates / this.pageSize)
          this.currentPage = 1
        } else {
          this.currentPage = 1
          this.totalPages = 0
        }
        this.load()
      }, 500)
      if (this.$store.isAuthenticated) {
        this.restoreSettings()
        this.load()
      }
    }

  }
</script>

<style scoped>
    .header div h1 {
        color: rgb(255, 70, 0);
        font-weight: lighter;
        font-size: 28px;
        margin: 0;
    }

    .header > h5 {
        margin-top: 0.5rem; /* Match bottom margin from bootstrap h5 */
    }

    .visits-header div {
        padding: 0.75rem;
        vertical-align: bottom;
        border-top: 1px solid #dee2e6;
        border-bottom: 2px solid #dee2e6;
        font-weight: bold;
        border-collapse: collapse;
    }

    .visit-row .column {
        padding: 0.75rem;
        vertical-align: bottom;
        border-collapse: collapse;
    }

    .visit-row {
        border-bottom: 1px solid #dee2e6;
        background-color: #f9f9f9;
        /*cursor: pointer;*/
    }
    .header-row {
      margin-top: 28px;
    }

    .patient-search {
      min-width: 220px;
      height: 36px;
    }

    .patient-search-section {
      margin-top: 28px;
    }
</style>
